import { SocketProvider } from "../../../context/socket";
import Configuration from "./Configuration";
import CreateTicket from "./CreateTicket";
import Home from "./Home";
import TicketDetail from "./TicketDetail";
const routes = [
  {
    key: "home",
    route: "/",
    component: <Home />,
  },
  {
    key: "home",
    route: "/configuration",
    component: <Configuration />,
  },
  {
    key: "create_ticket",
    route: "/create_ticket",
    component: <CreateTicket />,
  },
  {
    key: "ticket_detail",
    route: "/ticket_detail/:ticketId",
    component: (
      <SocketProvider>
        <TicketDetail />
      </SocketProvider>
    ),
  },
];

export default routes;
